var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.keepAlive && _vm.isGetCms && _vm.isLogin == true)?_c('router-view'):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive && _vm.isGetCms && _vm.isLogin == true)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }